import React from 'react';
import { Card, CardContent } from '../ui/card';
import { AlertTriangle } from 'lucide-react';

export const brl = (v) => (v == null ? '—' : new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v));
export const pct = (v) => (v == null ? '—' : `${v.toFixed(1).replace('.', ',')}%`);
export const num = (v) => (v == null ? '—' : new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 1 }).format(v));
export const days = (v, unidade) => (v == null ? '—' : `${num(v)} ${unidade === 'uteis' ? 'dias úteis' : 'dias'}`);
export const fmtDate = (ymd) => (ymd ? ymd.split('-').reverse().join('/') : '');

export const Delta = ({ value }) => {
  if (value == null) return <span className="text-muted-foreground">Sem base de comparação</span>;
  if (value === 0) return <span className="text-muted-foreground">— 0,0%</span>;
  return (
    <span className={value >= 0 ? 'text-green-600' : 'text-red-600'}>
      {value >= 0 ? '▲' : '▼'} {Math.abs(value).toFixed(1).replace('.', ',')}%
    </span>
  );
};

export const Insufficient = ({ title, message, testId }) => (
  <Card data-testid={testId}>
    <CardContent className="py-8 flex flex-col items-center text-center gap-2">
      <AlertTriangle className="h-5 w-5 text-amber-500" />
      {title && <p className="font-medium">{title}</p>}
      <p className="text-sm text-muted-foreground">{message}</p>
    </CardContent>
  </Card>
);

export const SectionTitle = ({ children, sub }) => (
  <div className="mb-3">
    <h2 className="text-lg font-semibold tracking-tight">{children}</h2>
    {sub && <p className="text-xs text-muted-foreground mt-0.5">{sub}</p>}
  </div>
);

// Message for a field that is still importing or not provided by the store.
export const fieldMessage = (status, field, ctx) => {
  if (status === 'empty') return 'Sem pedidos pagos no período selecionado.';
  if (status === 'importing') {
    return ctx.isPortal
      ? 'Estamos preparando os dados de logística da sua loja.'
      : `Importando dados de logística desta loja: ${ctx.progress ?? 0}%. Os números aparecem assim que a importação terminar.`;
  }
  return ctx.isPortal
    ? 'Análise indisponível para esta loja.'
    : `Esta loja não informa ${ctx.labels?.[field] || 'este dado'} para a plataforma. Esta análise não está disponível.`;
};

export const FieldNotice = ({ status, field, ctx, compact, testId }) => (compact
  ? <p className="text-xs text-muted-foreground mt-2" data-testid={testId}>{fieldMessage(status, field, ctx)}</p>
  : <Insufficient message={fieldMessage(status, field, ctx)} testId={testId} />);
